import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Controls, ControlsButton } from '@/components/Controls';
import FullScreenButton from '@/components/FullScreenButton';
import { PageHeading } from '@/components/Layout/Parts';
import { TableHeader } from '@/components/Table';

const tabs = [
  { label: 'Invoices', path: 'invoices/invoices-changelog' },
  { label: 'Payment Members', path: 'invoices/members-changelog' },
  { label: 'Bank Accounts', path: 'invoices/bank-accounts-changelog' },
];

const FinancesChangelog = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <>
      <PageHeading>Changelog</PageHeading>
      <TableHeader>
        <Controls>
          {tabs.map((tab) => (
            <ControlsButton
              key={tab.path}
              active={pathname === `/general/${tab.path}`}
              onClick={() => navigate(`/general/${tab.path}`)}
            >
              {tab.label}
            </ControlsButton>
          ))}
        </Controls>
        <FullScreenButton />
      </TableHeader>
      <Outlet />
    </>
  );
};

export default FinancesChangelog;
